import ApplicationController from './application_controller'
import { useDispatch } from 'stimulus-use'

export default class extends ApplicationController {
  static values = {
    detail: Object,
    dispatchOptions: Object,
    dispatchOnConnect: Boolean,
    dispatchOnDisconnect: Boolean
  }

  doConnect() {
    this._parentElement = this.element.parentElement
    this._dispatcher = useDispatch(this, this.dispatchOptionsValue)

    if (this.dispatchOnConnect) this.dispatchEvent()
  }

  disconnect() {
    if (this.dispatchOnDisconnect) {
      // Since on disconnect the current target element has been removed already,
      // we need to set the target element dispatcher to something else.
      this._dispatcher.targetElement = this._parentElement
      this.dispatchEvent()
    }
  }

  afterConnect() {
    if (!this.hasDetailValue) {
      this.detailValue = {}
    }
  }

  dispatchEvent() {
    if (!this.isActionDisabled('dispatchEvent')) {
      const eventName = this.data.get('eventName')

      if (eventName) {
        this.dispatch(eventName, this.detailValue)
      } else {
        console.error('ERROR: Event Dispathcher - not provided event name')
      }
    }
  }

  get dispatchOnConnect() {
    return this.hasDispatchOnConnectValue && this.dispatchOnConnectValue
  }

  get dispatchOnDisconnect() {
    return this.hasDispatchOnDisconnectValue && this.dispatchOnDisconnectValue
  }
}
